var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-divider",style:({
    '--height': _vm.computedHeight,
    '--bg-color': _vm.color,
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }